import { Link } from 'react-router-dom';
import './Page.css';

export default function Editions() {
  return (
    <div className='page'>
      <div className='poster-container'>
        <div className='poster-container-single'>
          <Link to='/'>
            <img
              className='poster'
              src={`${process.env.PUBLIC_URL}/img/otwarte-pracownie-plakat-edycji-2025.jpg`}
            />
          </Link>

          <h3 className='subheadline-upper'>2025</h3>
        </div>
        <div className='poster-container-single'>
          <a
            href={`${process.env.PUBLIC_URL}/files/edycja-2024/edycja-2024.html`}
            target='_blank'
          >
            <img
              className='poster'
              src={`${process.env.PUBLIC_URL}/img/otwarte-pracownie-plakat-edycji-2024.jpg`}
            />
          </a>

          <h3 className='subheadline-upper'>2024</h3>
        </div>
        <div className='poster-container-single'>
          <a
            href={`${process.env.PUBLIC_URL}/files/edycja-2023/otwarte-pracownie-2023.pdf`}
            target='_blank'
          >
            <img
              className='poster'
              src={`${process.env.PUBLIC_URL}/img/otwarte-pracownie-plakat-edycji-2023.jpg`}
            />
          </a>
          <h3 className='subheadline-upper'>2023</h3>
        </div>
      </div>
    </div>
  );
}
